import React from 'react';
import styled from 'styled-components';
import { space, layout, typography, color, position } from 'styled-system';
import Text, { TextProps } from '../text/Text';

export type H4Props = Omit<TextProps, 'tag'> & { tag?: 'h4' };

const StyledH4: React.FC<H4Props> = ({ children, tag, ...otherProps }) => (
    <Text h4 tag="h4" {...otherProps}>
        {children}
    </Text>
);

const H4 = styled(StyledH4)`
    line-height: ${({ theme }) => theme.lineHeights.title};
    ${space}
    ${layout}
  ${typography}
  ${color}
  ${position}
`;

H4.displayName = 'H4';
export default H4;
